<template>
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit" v-if="modalInfo.status == 'regist'">{{$i18nUtil.trans("message.RoleSetting.001","권한 등록")}}</div>
      <div class="tit" v-else>{{$i18nUtil.trans("message.RoleSetting.002","권한 관리")}}</div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

    <div class="modal-content" v-if="modalInfo.status == 'regist'">
      <RoleRegist
        v-bind:modalInfo="modalInfo"
        @closeModal="closeModal"
        @registRole="registRole"
      />
    </div>
    <div class="modal-content" v-else>
      <RoleManage
        v-bind:modalInfo="modalInfo"
        @closeModal="closeModal"
        @updateRole="updateRole"
      />
    </div>    
  </div>
</template>

<script>
import RoleManage from "./RoleManage";
import RoleRegist from "./RoleRegist";

export default {
  components: {
    RoleManage,
    RoleRegist,
  },
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },  
  methods: {
    closeModal() {
      this.$emit("close");
    },
    updateRole() {
      this.$emit("updateRole");
    },        
    registRole() {
      this.$emit("registRole");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/RoleSetting.vue